// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__ShHE2","active":"Pagination_active__vk51h","pagination_text":"Pagination_pagination_text__w02hG"};